import { Routes } from '@angular/router';
import { DirectorComponent } from "./director/director.component";
import { CollectPaymentComponent } from "./collect-payment/collect-payment.component";
import { DoneComponent } from './components/done/done.component';
import { FormDoneComponent } from './components/form-done/form-done.component';

export const routes: Routes = [
  { path: 'director/:ciphertext', component: DirectorComponent },
  { path: 'collect-payment/:ciphertext', component: CollectPaymentComponent },
  { path: 'done', component: DoneComponent },
  { path: 'form-done', component: FormDoneComponent },
];

